import window from 'window-or-global';

export const isDarkFeatureEnabled = (key) => {
	if (!window.document) {
		// Play nicely with tests
		return false;
	}

	const featuresMetaTag = window.document.querySelector('meta[name=ajs-enabled-dark-features]');

	if (featuresMetaTag) {
		const featureList = featuresMetaTag.content.split(',');
		return featureList.indexOf(key) > -1 && featureList.indexOf(`${key}.disable`) === -1;
	}
};
